import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {when} from 'lit/directives/when.js';
import {property} from 'lit/decorators/property.js';
import {msg} from '@lit/localize';
import {customElement} from 'lit/decorators/custom-element.js';
import store from '../../store';
import {selectFinalized} from '../../selectors';


@customElement('shared-specsheet-head')
export class SharedSpecsheetHead extends connect(store)(LitElement) {

	static styles = [
	css`
		:host {
			padding-bottom: 7mm;
			margin: 0;
		}

		.headline {
			container-type: inline-size;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
			width: 100%;
			margin: 0;
			padding: 0;
		}

		.title {
			font: var(--font-specsheet-print-title-bold);
			font-size: 2.5cqw;
			color: #000;
			margin: 0;
			padding: 0;
			line-height: 1.2;
			letter-spacing: 1px;
			flex: 2;
		}

		.subtitle {
			text-transform: uppercase;
			color: #000;;
			text-decoration: none;
			font: var(--font-specsheet-print-light);
			margin: 0;
			padding: 0;
			font-size: 1.1cqw;
		}

		.document-subtitle {
			font: var(--font-specsheet-print-light);
			color: var(--color-grey4);
			flex: 1;
			text-align: right;
			font-size: 1cqw;
		}

		a {
			color: black;
			text-decoration: none;
		}
	`
	];

	@property({type: String})
	headLabel = 'Specsheet';

	@property({type: String})
	title = null;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}


	stateChanged(state) {
		this.status = state.status;
		if (state.specsheet.data.specsheets && state.status.productFamily) {
			this.kirbySpecsheets = state.specsheet.data.specsheets;
			this.family = state.status.productFamily;
			this.kirbySpecsheet = this.kirbySpecsheets.find(specsheet => specsheet.id === this.family);
		}
		this.shortKey = this.status.shortKey;
		this.finalized = selectFinalized(state);
	}


	render() {
		return html`
			<div class="headline">

				<div class="flex-item title">
					<h2 class="title">
						${this.title !== null && this.title !== '' ? html`${this.title}` : html`${this.family}`}
					</h2>
					${when(this.finalized, () => html`
							<h3 class="subtitle">
								${msg('Specification ID')}:
								<a href="${this.status.host}${this.status.baseUrl}${this.status.region}/${this.status.lang}/${this.status.family}/sections/${this.shortKey}">${this.shortKey}</a>
							</h3>
						`
					)}
				</div>

				<div class="flex-item document-subtitle">
					${this.headLabel}
				</div>
			</div>
		`;
	}
}
